import {Box, CardMedia, Grid, Typography} from '@mui/material';

import {bodyPdf, pdfH3} from '../styles';

import {orangeColors} from '../../../../layouts/theme/designSystem';

interface Pillar {
  image: string;
  title: string;
  description: string;
}

interface Props {
  pillar: Pillar;
  index: number;
}

export const CulturePillarCard = ({pillar, index}: Props) => {
  const cardMediaStyle = {height: '200px', width: '200px', borderRadius: '16px'};

  return (
    <Grid item container mb={4} direction={'row'} key={pillar.title} position='relative'>
      <Box
        bgcolor={orangeColors[900]}
        height={30}
        width={30}
        borderRadius={'50%'}
        textAlign={'center'}
        alignContent={'center'}
        position='absolute'
        top={8}
        left={8}
        display='flex'
        alignItems='center'
        justifyContent='center'
        zIndex='tooltip'
      >
        <Typography sx={{...bodyPdf, color: 'white'}}>{index + 1}</Typography>
      </Box>
      <CardMedia component='img' image={pillar.image} sx={{mr: 2, ...cardMediaStyle}} />
      <Grid item width={'470px'}>
        <Typography variant='h3' sx={pdfH3} mb={2}>
          {pillar.title}
        </Typography>
        <Typography sx={bodyPdf} mb={2}>
          {pillar.description}
        </Typography>
      </Grid>
    </Grid>
  );
};
